import initialState from './initialState';
import * as actionTypes from '../actions/actionTypes';

// Create your Reducer here...
// Extend default state with cache if not defined
// Ensure state always has cache and statsLoading defaults
const ensureState = (state) => ({ cache: {}, statsLoading: false, ...state });

const reducerFetchEvent = (state = initialState, action) => {
  state = ensureState(state);
  switch (action.type) {
    case actionTypes.FETCH_EVENT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        collectionError: null,
        statsError: null,
        layoutError: null,
        ideasError: null,
        pulseStatsError: null,
        sentimentByRatingError: null,
        rosterError: null,
        // We null out the event on loading so that each new page loads its own event
        event: null,
        collection: null,
        stats: null,
        layout: null,
        ideas: null,
        pulseStats: null,
        sentimentByRating: null,
        roster: null,
        statsLoading: true
      };
    case actionTypes.FETCH_EVENT_SUCCESS:
      return {
        ...state,
        error: null,
        collectionError: null,
        event: action.event,
        collection: action.collection
      };
    case actionTypes.FETCH_EVENT_ERROR:
      return {
        ...state,
        error: action.error,
        collectionError: action.collectionError,
        event: null,
        collection: null,
        statsLoading: false
      };
    case actionTypes.FETCH_EVENT_DONE:
      return {
        ...state,
        loading: false,
        statsLoading: false
      };
    default:
      return state;
  }
};

const reducerFetchEventsAndPrioritize = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENTS_AND_PRIORITIZE_LOADING:
      return {
        ...state,
        eventsLoading: true
      };
    case actionTypes.FETCH_EVENTS_AND_PRIORITIZE_SUCCESS:
      return {
        ...state,
        events: action.payload
      };
    case actionTypes.FETCH_EVENTS_AND_PRIORITIZE_ERROR:
    case actionTypes.FETCH_EVENTS_AND_PRIORITIZE_DONE:
      return (({ eventsLoading, ...state }) => ({ ...state }))(state);
    default:
      return state;
  }
};


const reducerSyncFetchEventsAndPrioritize = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_LOADING:
      return {
        ...state,
        eventsLoading: true
      };
    case actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_SUCCESS:
      return {
        ...state,
        events: action.payload
      };
    case actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_ERROR:
      return {
        ...state,
        eventsError: true
      };
    case actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE_DONE:
      return (({ eventsLoading, ...state }) => ({ ...state }))(state);
    default:
      return state;
  }
};

const reducerDeleteEventOrPrioritize = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DELETE_EVENT_OR_PRIORITIZE:
      return {
        ...state,
        collectionToDelete: action.payload
      };
    case actionTypes.DELETE_EVENT_OR_PRIORITIZE_SUCCESS:
      return { ...state, deleteSuccessful: true }
    case actionTypes.DELETE_EVENT_OR_PRIORITIZE_ERROR:
      return {
        ...state,
        deleteSuccessful: false
      }
    case actionTypes.DELETE_EVENT_OR_PRIORITIZE_DONE:
      return (({ collectionToDelete, deleteSuccessful, ...state }) => ({ ...state }))(state)
    default:
      return state;
  }
};

const reducerFetchEventStats = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENT_STATS_SUCCESS:
      return {
        ...state,
        statsError: null,
        statsLoading: false,
         stats: action.stats
      };
    case actionTypes.FETCH_EVENT_STATS_ERROR:
      return {
        ...state,
        statsError: action.error,
        stats: null
      };
    default:
      return state;
  }
};

const reducerFetchEventStatsNew = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENT_STATS_NEW_SUCCESS:
      return {
        ...state,
        stats: action.payload
      };
    default:
      return state;
  }
};

const reducerFetchEventLayout = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EVENT_LAYOUT_SUCCESS:
      return {
        ...state,
        layoutError: null,
        layout: action.layout.sections
      };
    case actionTypes.FETCH_EVENT_LAYOUT_ERROR:
      return {
        ...state,
        layoutError: action.error,
        layout: null
      };
    default:
      return state;
  }
};

const reducerFetchEventIdeas = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_IDEAS_SUCCESS:
      return {
        ...state,
        ideasError: null,
        ideas: action.ideas
      };
    case actionTypes.FETCH_IDEAS_ERROR:
      return {
        ...state,
        ideasError: action.error,
        ideas: null
      };
    default:
      return state;
  }
};

const reducerFetchEventPulses = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PULSES_SUCCESS:
      return {
        ...state,
        pulseStatsError: null,
        pulseStats: action.pulseStats
      };
    case actionTypes.FETCH_PULSES_ERROR:
      return {
        ...state,
        pulseStatsError: action.error,
        pulseStats: null
      };
    default:
      return state;
  }
};

const reducerFetchEventRoster = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ROSTER_SUCCESS:
      return {
        ...state,
        rosterError: null,
        roster: action.roster[0]
      };
    case actionTypes.FETCH_ROSTER_ERROR:
      return {
        ...state,
        rosterError: action.error,
        roster: null
      };
    default:
      return state;
  }
};

const reducerFetchEventSentimentByRating = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SENTIMENT_BY_RATING_SUCCESS:
      return {
        ...state,
        sentimentByRatingError: null,
        sentimentByRating: action.sentimentByRating
      };
    case actionTypes.FETCH_SENTIMENT_BY_RATING_ERROR:
      return {
        ...state,
        sentimentByRatingError: action.error,
        sentimentByRating: null
      };
    default:
      return state;
  }
};

const reducerUpdateEventLayout = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_EVENT_LAYOUT_LOADING:
      return {
        ...state,
        layoutLoading: true,
        layoutError: null,
        // We null out the stats on loading so that each new page loads its own stats
        layout: null
      };
    case actionTypes.UPDATE_EVENT_LAYOUT_SUCCESS:
      return {
        ...state,
        layoutError: null,
        layout: action.layout.sections
      };
    case actionTypes.UPDATE_EVENT_LAYOUT_ERROR:
      return {
        ...state,
        layoutError: action.error,
        layout: null
      };
    case actionTypes.UPDATE_EVENT_LAYOUT_DONE:
      return {
        ...state,
        layoutLoading: false
      };
    default:
      return state;
  }
};

const reducerAttachRoster = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ATTACH_ROSTER_LOADING:
      return {
        ...state,
        rosterLoading: true,
        rosterError: null,
        roster: null
      };
    case actionTypes.ATTACH_ROSTER_SUCCESS:
      return {
        ...state,
        rosterError: null,
        event: action.event
      };
    case actionTypes.ATTACH_ROSTER_ERROR:
      return {
        ...state,
        rosterError: action.error,
        roster: null
      };
    case actionTypes.ATTACH_ROSTER_DONE:
      return {
        ...state,
        rosterLoading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  state = ensureState(state);

  // Global cache handlers
  if (action.type === actionTypes.STORE_EVENT_CACHE) {
    return {
      ...state,
      cache: {
        ...state.cache,
        [action.eventId]: { data: action.data, fetchedAt: action.fetchedAt }
      }
    };
  }

  if (action.type === actionTypes.USE_CACHED_EVENT) {
    return {
      ...state,
      loading: false,
      error: null,
      collectionError: null,
      event: action.data.event || null,
      statsLoading: false,
      collection: action.data.collection ?? null,
      stats: action.data.stats ?? null,
      layout: action.data.layout ?? null,
      pulseStats: action.data.pulseStats ?? null,
      roster: action.data.roster ?? null,
      ideas: action.data.ideas ?? null,
      sentimentByRating: action.data.sentimentByRating ?? null
    };
  }
  if (action.type.startsWith(actionTypes.FETCH_EVENT_STATS_NEW_SUCCESS)) {
    return reducerFetchEventStatsNew(state, action);
  } else if (action.type.startsWith(actionTypes.DELETE_EVENT_OR_PRIORITIZE)) {
    return reducerDeleteEventOrPrioritize(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_EVENT_STATS)) {
    return reducerFetchEventStats(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_IDEAS)) {
    return reducerFetchEventIdeas(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_ROSTER)) {
    return reducerFetchEventRoster(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_PULSES)) {
    return reducerFetchEventPulses(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_SENTIMENT_BY_RATING)) {
    return reducerFetchEventSentimentByRating(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_EVENT_LAYOUT)) {
    return reducerFetchEventLayout(state, action);
  } else if (action.type.startsWith(actionTypes.ATTACH_ROSTER)) {
    return reducerAttachRoster(state, action);
  } else if (action.type.startsWith(actionTypes.UPDATE_EVENT_LAYOUT)) {
    return reducerUpdateEventLayout(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_EVENTS_AND_PRIORITIZE)) {
    return reducerFetchEventsAndPrioritize(state, action);
  } else if (action.type.startsWith(actionTypes.SYNC_FETCH_EVENTS_AND_PRIORITIZE)) {
    return reducerSyncFetchEventsAndPrioritize(state, action);
  } else if (action.type.startsWith(actionTypes.FETCH_EVENT)) {
    return reducerFetchEvent(state, action);
  } else {
    return state;
  }
};
